import React, { useState, useEffect } from "react";
import { inkredoBSP } from "../api";
import UploadOnly from "../components/UploadOnly";
import { BanksList } from "../util/constants";
import { Button, CircularProgress } from "@mui/material";
import CustomInputAutocomplete from "../components/AutoComplete";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

export default function BankStatement() {
  const [bank, setBank] = React.useState("");
  const [banks, setBanks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [bsError, setBsError] = useState(false);
  const [bsErrorTxt, setBsErrorTxt] = useState("");
  const [apiPayload, setApiPayload] = useState({
    applicant_key: "31d1ed1a-1dd6-445f-a2ba-67fc7f179ff6",
    base64_str: "",
    bank_code: "",
  });
  const [apiResponse, setApiResponse] = useState(null);
  const [copyWhole, setCopyWhole] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({
    bankCode: "",
  });
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    getBankList();
  }, []);

  const getBankList = () => {
    BanksList.forEach((val) => {
      banks.push(val);
    });
    setBanks(banks);
  };

  const isValid = () => {
    let valid = true;

    if (!bank in banks) {
      setFieldErrors({ ...fieldErrors, bankCode: "Invalid Input" });
      valid = false;
    }

    if (apiPayload.base64_str === "") {
      setBsError(true);
      setBsErrorTxt("cannot be blank");
      valid = false;
    }

    return valid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    if (isValid()) {
      try {
        const { data } = await inkredoBSP(apiPayload);
        console.log(data);
        setCopyWhole(data["body"]);
        let fileKey = data["file_key"];
        let account_num =
          data["body"]["data"]["analysis"]["by_file"][fileKey]["pii"][
            "account_number"
          ];
        console.log(
          data["body"]["data"]["analysis"]["by_file"][fileKey][account_num][
            "summary"
          ]
        );
        setApiResponse(
          data["body"]["data"]["analysis"]["by_file"][fileKey][account_num][
            "summary"
          ]
        );
      } catch (error) {
        enqueueSnackbar(error.response.data.errors[0].message, {
          variant: "error",
        });
        console.log(error);
      }
    }
    setIsLoading(false);
  };

  const handleGoBack = (e) => {
    setApiResponse(null);
    setCopyWhole(null);
    setApiPayload({
      applicant_key: "31d1ed1a-1dd6-445f-a2ba-67fc7f179ff6",
      base64_str: "",
      bank_code: "",
    });
  };

  return !apiResponse ? (
    <>
      <div className="main-card">
        <div className="container-card">
          <h1 className="chooser-head"> Choose Bank :</h1>

          <form onSubmit={handleSubmit}>
            <CustomInputAutocomplete
              options={banks}
              onChange={(val) => {
                setFieldErrors((prev) => ({ ...prev, parser: "" }));
                setApiPayload({ ...apiPayload, bank_code: val.split(", ")[1] });
              }}
            />
            <span className="error">{fieldErrors.bankCode}</span>

            <h1 className="chooser-head mb-3 mt-3"> Upload Bank Statement :</h1>
            <div className="upload-container">
              <UploadOnly
                error={bsError}
                errorTxt={bsErrorTxt}
                setFile={(file) => {
                  setBsError(false);
                  setBsErrorTxt("");
                  setApiPayload((prev) => ({
                    ...prev,
                    base64_str: file,
                  }));
                }}
                tempState={apiPayload.base64_str}
              />
            </div>

            <Button
              className="btn-submit"
              type="submit"
              fullWidth
              disabled={isLoading}
              variant="contained"
              sx={{ mt: 1, mb: 1 }}
              onClick={handleSubmit}
            >
              {" "}
              {isLoading ? (
                <>
                  <CircularProgress
                    className="me-2 mb-1"
                    size={20}
                    style={{ color: "white", marginRight: "6px" }}
                  />
                  Loading
                </>
              ) : (
                "Submit"
              )}
            </Button>
          </form>
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="main-card">
        <div className="copy-option">
          <button
            onClick={() => {
              navigator.clipboard.writeText(
                JSON.stringify(apiResponse, null, 2)
              );
              enqueueSnackbar("copied!", {
                variant: "success",
              });
            }}
          >
            <u>Copy summary</u>
          </button>
          <button
            onClick={() => {
              navigator.clipboard.writeText(JSON.stringify(copyWhole, null, 2));
              enqueueSnackbar("copied!", {
                variant: "success",
              });
            }}
          >
            <u>Copy Whole</u>
          </button>
        </div>
        <pre style={{ width: "100%", height: "95%" }}>
          {JSON.stringify(apiResponse, null, 2)}
        </pre>
        <Button
          className="btn-submit"
          type="submit"
          fullWidth
          disabled={isLoading}
          variant="contained"
          sx={{ mt: 1, mb: 1 }}
          onClick={handleGoBack}
        >
          {" "}
          {isLoading ? (
            <>
              <CircularProgress
                className="me-2 mb-1"
                size={20}
                style={{ color: "white", marginRight: "6px" }}
              />
              Loading
            </>
          ) : (
            "Go Back"
          )}
        </Button>
      </div>
      <></>
    </>
  );
}
